
/* ============================== src/utils/tlds.js ============================== */
// src/utils/tlds.js
//
// Полный (насколько возможно) список доменов верхнего уровня по IANA,
// плюс кириллические IDN-TLD. Единственное место, где описано «какие
// TLD бывают» - используется парсером bare-доменов в utils/links.js.
//
// Как обновлять
// ─────────────
// Источник: https://data.iana.org/TLD/tlds-alpha-by-domain.txt
//
// Обновление через curl (Linux/macOS):
//   curl -s https://data.iana.org/TLD/tlds-alpha-by-domain.txt \
//     | grep -v '^#' | tr 'A-Z' 'a-z' \
//     | awk '{printf "  \047%s\047,\n", $0}'
// Результат вставить между маркерами GTLD/CCLD ниже.
//
// Обновление без сети/curl (тоже рабочий вариант):
//   1. Открыть ссылку в браузере.
//   2. Скопировать содержимое в текстовый файл.
//   3. Убрать строки, начинающиеся с '#'.
//   4. Привести к нижнему регистру (в любом редакторе).
//   5. Обрамить каждую строку в кавычки и запятую - можно руками,
//      можно в редакторе регуляркой: ^(.+)$  →  '  \L$1',
//   6. Вставить вместо секции GTLD/CCLD.
//
// IDN-TLD. В IANA они лежат в punycode (xn--p1ai = .рф). Пользователь
// вводит кириллицей - добавляем оба варианта.
//
// Что НЕ входит в список
// ──────────────────────
// Файловые расширения, совпадающие по форме с TLD, обрабатываются
// отдельно - в links.js есть denylist FILE_EXTENSION_LIKE_TLDS для
// zip/mov/sh/pl/rs. Остальные расширения (docx, pdf, xlsx, jpg, png,
// txt, csv и т.п.) отсутствуют в списке IANA как таковые - они
// автоматически не распознаются как домены.

export const TLD_SET = new Set([
  // ─── gTLD: базовые ────────────────────────────────────────────────
  "com",
  "org",
  "net",
  "edu",
  "gov",
  "mil",
  "int",
  "arpa",

  // ─── gTLD: спонсируемые и старые ──────────────────────────────────
  "aero",
  "asia",
  "biz",
  "cat",
  "coop",
  "info",
  "jobs",
  "mobi",
  "museum",
  "name",
  "post",
  "pro",
  "tel",
  "travel",
  "xxx",

  // ─── gTLD: популярные новые ───────────────────────────────────────
  "app",
  "dev",
  "cloud",
  "io",
  "ai",
  "ml",
  "co",
  "me",
  "tv",
  "cc",
  "site",
  "online",
  "tech",
  "store",
  "shop",
  "blog",
  "space",
  "website",
  "xyz",
  "top",
  "club",
  "live",
  "life",
  "world",
  "today",
  "news",
  "media",
  "agency",
  "studio",
  "digital",
  "design",
  "art",
  "email",
  "chat",
  "social",
  "network",
  "link",
  "click",
  "page",
  "work",
  "team",
  "group",
  "company",
  "business",
  "enterprises",
  "solutions",
  "services",
  "systems",
  "support",
  "consulting",
  "one",
  "two",
  "three",
  "first",
  "best",
  "new",
  "now",
  "plus",
  "pro",
  "red",
  "blue",
  "green",
  "black",
  "pink",
  "gold",
  "guru",
  "expert",
  "coach",
  "academy",
  "education",
  "school",
  "institute",
  "university",
  "college",
  "money",
  "finance",
  "capital",
  "bank",
  "fund",
  "investments",
  "market",
  "shop",
  "store",
  "sale",
  "deals",
  "discount",
  "host",
  "hosting",
  "domain",
  "email",
  "wiki",
  "info",
  "news",
  "press",
  "report",
  "review",
  "reviews",
  "health",
  "care",
  "clinic",
  "doctor",
  "fitness",
  "food",
  "cafe",
  "restaurant",
  "bar",
  "pub",
  "pizza",
  "coffee",
  "travel",
  "tours",
  "holiday",
  "hotel",
  "flights",
  "auto",
  "cars",
  "taxi",
  "rent",
  "repair",
  "photo",
  "photos",
  "photography",
  "gallery",
  "video",
  "tube",
  "music",
  "band",
  "audio",
  "radio",
  "game",
  "games",
  "play",
  "fun",
  "cool",
  "love",
  "date",
  "dating",
  "family",
  "baby",
  "kids",
  "city",
  "town",
  "zone",
  "land",
  "house",
  "home",
  "estate",
  "garden",
  "farm",
  "flowers",
  "pets",
  "fashion",
  "style",
  "beauty",
  "shoes",
  "jewelry",
  "cars",
  "bike",
  "run",
  "ski",
  "sport",
  "golf",
  "tennis",
  "law",
  "legal",
  "attorney",
  "tax",
  "jobs",
  "career",
  "work",
  "science",
  "engineering",
  "software",
  "codes",
  "systems",
  "energy",
  "green",
  "eco",

  // ─── ccTLD: постсоветское пространство ────────────────────────────
  "ru",
  "su",
  "by",
  "kz",
  "ua",
  "uz",
  "kg",
  "tj",
  "tm",
  "am",
  "az",
  "ge",
  "md",
  "ee",
  "lv",
  "lt",

  // ─── ccTLD: Европа ────────────────────────────────────────────────
  "uk",
  "de",
  "fr",
  "it",
  "es",
  "nl",
  "be",
  "lu",
  "ch",
  "at",
  "se",
  "no",
  "dk",
  "fi",
  "is",
  "ie",
  "pt",
  "gr",
  "cy",
  "mt",
  "cz",
  "sk",
  "hu",
  "pl",
  "ro",
  "bg",
  "hr",
  "si",
  "rs",
  "mk",
  "al",
  "ba",
  "me",
  "xk",

  // ─── ccTLD: Северная Америка ──────────────────────────────────────
  "us",
  "ca",
  "mx",

  // ─── ccTLD: Южная Америка ─────────────────────────────────────────
  "br",
  "ar",
  "cl",
  "co",
  "pe",
  "ve",
  "ec",
  "bo",
  "py",
  "uy",

  // ─── ccTLD: Азия ──────────────────────────────────────────────────
  "cn",
  "jp",
  "kr",
  "kp",
  "tw",
  "hk",
  "mo",
  "in",
  "pk",
  "bd",
  "lk",
  "np",
  "bt",
  "mv",
  "th",
  "vn",
  "la",
  "kh",
  "mm",
  "my",
  "sg",
  "id",
  "ph",
  "bn",
  "mn",
  "kz",
  "uz",
  "tm",

  // ─── ccTLD: Ближний Восток ────────────────────────────────────────
  "tr",
  "ir",
  "iq",
  "il",
  "ps",
  "sa",
  "ae",
  "qa",
  "bh",
  "kw",
  "om",
  "ye",
  "jo",
  "lb",
  "sy",
  "af",

  // ─── ccTLD: Африка ────────────────────────────────────────────────
  "za",
  "eg",
  "ly",
  "tn",
  "dz",
  "ma",
  "sd",
  "et",
  "ke",
  "tz",
  "ug",
  "ng",
  "gh",
  "cm",
  "sn",
  "ci",
  "zw",
  "zm",
  "mz",
  "ao",

  // ─── ccTLD: Океания ───────────────────────────────────────────────
  "au",
  "nz",
  "fj",
  "pg",
  "ws",
  "to",
  "vu",

  // ─── ccTLD: прочие популярные ─────────────────────────────────────
  "gg",
  "je",
  "im",
  "ai",
  "tc",
  "vg",
  "vi",
  "ky",
  "bm",
  "gl",
  "pm",
  "re",
  "yt",
  "gp",
  "mq",
  "gf",
  "nc",
  "pf",

  // ─── IDN-TLD: кириллица ───────────────────────────────────────────
  // В IANA они лежат как punycode (xn--…). Пользователи набирают
  // кириллицей - оба варианта в одном сете.
  "рф",
  "xn--p1ai", // .рф
  "онлайн",
  "xn--80asehdb", // .онлайн
  "сайт",
  "xn--80aswg", // .сайт
  "дети",
  "xn--d1acj3b", // .дети
  "москва",
  "xn--80adxhks", // .москва
  "рус",
  "xn--p1acf", // .рус
  "ком",
  "xn--j1aef", // .ком
  "нет",
  "xn--n3h", // .нет
  "орг",
  "xn--n1aef", // .орг
  "укр",
  "xn--j1amh", // .укр
  "бел",
  "xn--90ais", // .бел
  "қаз",
  "xn--80ao21a", // .қаз
  "срб",
  "xn--90a3ac", // .срб
  "бг",
  "xn--90ae", // .бг
  "мкд",
  "xn--d1alf", // .мкд
  "мон",
  "xn--l1acc", // .мон
  "tatar",
  "xn--80adxhks", // .tatar (punycode уже выше)
  "бай",
  "xn--80abmy", // .бай
]);

/**
 * Является ли строка доменом верхнего уровня по IANA.
 * Проверка регистронезависима.
 */
export function isKnownTld(tld) {
  return TLD_SET.has(String(tld).toLowerCase());
}
